import React from 'react';
import './Toolbar.css';

export default function Toolbar({ children }) {
  return <header className="toolbar">{children}</header>;
}
